import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  SelectWrapper,
  OptionsWrapper,
  ButtonWrapper,
  SelectedOption,
  Option,
} from './styles';
import IconFont from '../IconFont';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  show = () => {
    this.setState({ isOpen: true });
    document.addEventListener('click', this.hide);
  };

  hide = () => {
    this.setState({ isOpen: false });
    document.removeEventListener('click', this.hide);
  };

  selectOption = (option) => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
    this.props.changeOption(option);
  };

  moveToCurrentSelect = (itemPos) => {
    document.querySelector('.optionContainer').scrollTo(0, itemPos);
  };

  render() {
    const { isOpen } = this.state;
    const { options, selectedOption, dictionary } = this.props;
    return (
      <SelectWrapper>
        {selectedOption &&
          <SelectedOption onClick={this.show}>
            {selectedOption}{dictionary.competitionTable.dayA}
          </SelectedOption>
        }
        <OptionsWrapper isOpen={isOpen} className="optionContainer">
          {options && options.map((option, id) => (
            <Option
              onClick={() => {
                this.selectOption(option);
              }}
              key={id}
              className={selectedOption === option ? 'isActive' : 'notActive'}
            >
              {option}{dictionary.competitionTable.dayA}
            </Option>
          ))}
        </OptionsWrapper>
        <ButtonWrapper onClick={this.show}>
          <IconFont
            className="icon-matchcenter-arrows"
            onClick={() => {
              this.moveToCurrentSelect(document.querySelector('.isActive').offsetTop);
            }}
            font={16}
            color="white"
            lineHeight={1.25}
            withCursor
            marginLeft={0.13}
          />
        </ButtonWrapper>
      </SelectWrapper>
    );
  }
}
Dropdown.propTypes = {
  options: PropTypes.any,
  selectedOption: PropTypes.any,
  changeOption: PropTypes.func,
  dictionary: PropTypes.any,
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/shared/Dropdown/index.js